import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  :root {
    --bg: #0b0b0b;           /* near-black */
    --text: #f5f5f5;         /* near-white */
    --muted: #a3a3a3;        /* neutral-400 */
    --accent: #dc2626;       /* red-600 */
    --accent-light: #f87171; /* red-400 */
    --accent-contrast: #ffffff;
    --border: #262626;       /* neutral-800 */
    --surface: #111111;      /* dark card/form/table */
  }

  * { margin: 0; padding: 0; box-sizing: border-box; }
  html, body, #root { height: 100%; }
  body {
    background: var(--bg);
    color: var(--text);
    font-family: system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, "Apple Color Emoji", "Segoe UI Emoji";
    line-height: 1.5;
  }
  a { color: var(--accent); text-decoration: none; }
  a:hover { text-decoration: underline; }
`;
